import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {bindActionCreators} from 'redux'
import {logUserOut} from '../../../application.actions';
import * as selectors from '../../../application.selectors';

const Logout = styled.a`
  cursor: pointer; 
`;

const UserInfo = ({user, logUserOut, epasrrUrl}) => (
    <div className="utility-menu col-xs-12 col-sm-8 col-md-6 pull-right hidden-print">
        <ul className="navbar-nav nav navbar-right pull-right">
            <li className="login-list">
                <span id="username-label">Logged in as: </span>
                <span>
          {user.email} &nbsp;&nbsp;|
      </span>
            </li>
            <li className="login-list">
                <span><Logout href={epasrrUrl} onClick={logUserOut}>Logout</Logout></span>
            </li>
        </ul>
        <div style={{clear: 'both'}}/>
    </div>
)
UserInfo.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  logUserOut: PropTypes.func.isRequired
};

export default connect(
    state => ({
        user: selectors.user(state),
        epasrrUrl: selectors.epasrrUrl(state)
    }),
    dispatch => ({logUserOut: bindActionCreators(logUserOut, dispatch)})
)(UserInfo);



// WEBPACK FOOTER //
// ./src/modules/layout/components/UserInfo.js